<div class="wrapper light-disabled-border-color">
    <div id="dropin-container"></div>
    <div class="pv-button" [ngClass]="{ disabled: !requestable && !saveTokenOnly }" (click)="processPayment()">Save</div>
</div>